import { storeUrl } from "@/lib/the190";
import { trackOutbound } from "@/lib/analytics";

export const CollectCta = ({
  label,
  content,
  href,
  variant = "solid", // solid | outline | quiet
  dark = false,
  className = "",
  testid,
}) => {
  const base =
    "hairline inline-block text-center transition-colors duration-500 !text-[0.72rem]";
  const styles = {
    solid: dark
      ? "bg-[color:var(--bone)] text-[color:var(--ink)] px-8 py-4 hover:bg-[color:var(--ochre)]"
      : "bg-[color:var(--ink)] text-[color:var(--bone)] px-8 py-4 hover:bg-[color:var(--oxblood)]",
    outline: dark
      ? "border border-[color:var(--bone)] px-8 py-4 hover:bg-[color:var(--bone)] hover:text-[color:var(--ink)]"
      : "border border-[color:var(--ink)] px-8 py-4 hover:bg-[color:var(--ink)] hover:text-[color:var(--bone)]",
    quiet: "underline underline-offset-8 opacity-80 hover:opacity-100",
  };
  return (
    <a
      href={storeUrl(content, href)}
      onClick={() => trackOutbound(content)}
      data-testid={testid}
      className={`${base} ${styles[variant]} ${className}`}
    >
      {label}
    </a>
  );
};

export default CollectCta;
